import useVisibleNavigationMenu from '@Guidelines/Shell/AppShell/Hooks/useVisibleNavigationMenu';
import type { NavigationMenuSectionId } from '@UI/Routing/navigationMenu';
import NavigationMenuSection from '@Guidelines/Shell/AppShell/Menu/NavigationMenu/NavigationMenuSection';
import { css } from '@emotion/react';
import type * as React from 'react';

const menuStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;

type Props = {
	/** Restricts the menu to these sections; absent, every section is shown. Must be a stable reference. */
	readonly sectionIds?: readonly NavigationMenuSectionId[];
	readonly ariaLabel?: string;
};

/** The application's navigation, shared by the mobile drawer and the settings panel. Renders nothing while permissions resolve. */
const NavigationMenu: React.FC<Props> = ({ sectionIds, ariaLabel = 'Navigation principale' }) => {
	const sections = useVisibleNavigationMenu(sectionIds);

	if (sections.length === 0) {
		return null;
	}

	return (
		<nav css={menuStyle} aria-label={ariaLabel}>
			{sections.map((section) => (
				<NavigationMenuSection key={section.id} section={section} />
			))}
		</nav>
	);
};

export default NavigationMenu;
